module.exports = __webpack_public_path__ + "img/pineapple.5f6f9cd7.jpg";